// extracted by mini-css-extract-plugin
export var $animation_name = "ProductPersonalisationLimited-module--$animation_name--b2821";
export var Error = "ProductPersonalisationLimited-module--Error--54894";
export var Error___active = "ProductPersonalisationLimited-module--Error___active--22a25";
export var ProductPersonalisation = "ProductPersonalisationLimited-module--ProductPersonalisation--3cbd5";